import { Component, OnInit, inject } from '@angular/core';
import { DialogOverlayRef } from '@app/core/classes/dialog.ref';
import { InternationalizationService } from '@app/core/services';

// const config = {
//   data: {},
//   header: this.i18n.str('challengeu.Server Error'),
//   showHeader: true,
//   message: this.i18n.str('challengeu.There was an error'),
//   showAcceptButton: false,
//   showCancelButton: true,
//   acceptButtonLabel: this.i18n.str('challengeu.OK'),
//   cancelButtonLabel: this.i18n.str('challengeu.CLOSE'),
// }

export class DialogConfig {
	data?: any;
	header?: string;
	footer?: string;
	message?: string;
	showHeader?: boolean;
  showAcceptButton? : boolean;
  showCancelButton? : boolean;
  acceptButtonLabel? : string;
  cancelButtonLabel? : string;
}

@Component({
    selector: 'jeopardy-game-error',
    templateUrl: './game-error.component.html',
    styleUrls: ['./game-error.component.scss'],
    standalone: true
})
export class GameErrorComponent implements OnInit {
  config: any;

  public i18n = inject(InternationalizationService);
  private overlayRef = inject(DialogOverlayRef)

  ngOnInit(): void {
    const DEFAULT_CONFIG: DialogConfig  = {
      data: {},
      header: this.i18n.str('challengeu.dialog_error_title','Error')(),
      showHeader: true,
      message: this.i18n.str('challengeu.dialog_error','There was an error')(),
      showAcceptButton: true,
      showCancelButton: true,
      acceptButtonLabel: this.i18n.str('challengeu.dialog_ok','OK')(),
      cancelButtonLabel: this.i18n.str('challengeu.dialog_cancel','CANCEL')(),
    };

    this.config = {...DEFAULT_CONFIG, ...this.overlayRef.config};
  }

  close(event: Event, value: boolean) {
    event.preventDefault();
    this.overlayRef.close(value);
  }

}
